export const transformRequestOrderRecoveryLink = ({ portalId, email }) => {
  return {
    portal_id: portalId,
    customer_email: email,
  }
}
